// components/DetailVehicleAssignList.jsx
'use client';
import { useMemo } from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Stack } from '@mui/material';
import dayjs from 'dayjs';
import DetailDialog from '../../../components/DetailDialog';
import { useLanguage } from '../../../utils/i18n';

export default function DetailVehicleAssignList({ open, onClose, routeName = '', vehicles = [] }) {
  const { t } = useLanguage();
  const sortedVehicles = useMemo(() => {
    return [...(vehicles || [])].sort((a, b) => {
      const dateA = dayjs(a.valid_date || a.assign_date);
      const dateB = dayjs(b.valid_date || b.assign_date);
      return dateB.isAfter(dateA) ? 1 : -1;
    });
  }, [vehicles]);

  return (
    <DetailDialog
      open={open}
      onClose={onClose}
      title={`${t('masterRoute.listVehiclesRoute', 'Vehicle List for Route:')} ${routeName}`}
      maxWidth="sm"
      fullWidth
      actions={
        <Button onClick={onClose} variant="contained" sx={{ textTransform: 'none', px: 3 }}>
          {t('general.close', 'Close')}
        </Button>
      }
    >
      <Box>
        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
          <Typography variant="h5" sx={{ fontWeight: 600, color: '#4b5563' }}>
            {t('masterRoute.totalRegisteredVehicles', 'Total Registered Vehicles:')} {sortedVehicles.length}
          </Typography>
        </Stack>

        <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #e5e7eb', borderRadius: 2 }}>
          <Table size="small">
            <TableHead sx={{ bgcolor: '#f9fafb' }}>
              <TableRow>
                <TableCell width="60px" align="center" sx={{ fontWeight: 600, color: '#4b5563' }}>
                  {t('masterRoute.no', 'No')}
                </TableCell>
                <TableCell sx={{ fontWeight: 600, color: '#4b5563' }}>
                  {t('masterRoute.licensePlateVehicleName', 'License Plate / Vehicle Name')}
                </TableCell>
                <TableCell width="180px" align="center" sx={{ fontWeight: 600, color: '#4b5563' }}>
                  {t('masterRoute.assignDate', 'Assignment Date')}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sortedVehicles.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={3} align="center" sx={{ py: 3, fontStyle: 'italic', color: 'text.secondary' }}>
                    {t('masterRoute.noVehicleAssigned', 'No vehicles assigned for this route yet.')}
                  </TableCell>
                </TableRow>
              ) : (
                sortedVehicles.map((item, index) => {
                  const plate = item.join?.vehicle_license_plate || item.vehicle_license_plate || item.vehicle_name || '-';
                  const assignDate = item.valid_date || item.assign_date;

                  return (
                    <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                      <TableCell align="center">
                        <Typography variant="body2" fontWeight="bold">
                          {index + 1}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" fontWeight="600" color="#111827">
                          {plate}
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography variant="body2" color="#374151">
                          {assignDate ? dayjs(assignDate).format('DD MMM YYYY') : '-'}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </DetailDialog>
  );
}
